import {baseApi} from "../baseApi";
import {
    ICreateProcedure,
    ICreateSpeciality, IDoctorSaveBody,
    IDoctorsResponse, IDoctorUrlParams, IEditProcedure,
    IEditSpeciality,
    IGetDoctorsFilter,
    IOneDoctorsResponse, IProcResponse,
    ISpecResponse
} from "./types";

const endpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDoctors: builder.query<IDoctorsResponse, IGetDoctorsFilter>({
            query: ({id, ...params}) => ({
                url: `api/adm/doctors/address/${id}`,
                method: 'GET',
                params: {...params}
            }),
            providesTags: ['doctor'],
        }),
        getOneDoctors: builder.query<IOneDoctorsResponse, IDoctorUrlParams>({
            query: ({doctorId, addressId}) => ({
                url: `api/adm/doctors/${doctorId}/address/${addressId}`,
                method: 'GET',
            }),
            providesTags: ['doctor'],
        }),
        getSpecialities: builder.query<ISpecResponse, string>({
            query: (param) => ({
                url: `api/city/1/specialities`,
                method: 'GET',
            }),
            providesTags: ['doctor'],
        }),
        getProcedures: builder.query<IProcResponse, string>({
            query: (param) => ({
                url: `api/adm/procedures`,
                method: 'GET',
            }),
            providesTags: ['doctor'],
        }),
        createSpeciality: builder.mutation<any, ICreateSpeciality>({
            query: (body) => ({
                url: `api/adm/doctors/specialities`,
                method: 'POST',
                body:{...body}
            }),
            invalidatesTags: ['doctor'],
        }),
        editSpeciality: builder.mutation<any, IEditSpeciality>({
            query: ({id,body}) => ({
                url: `api/adm/doctors/specialities/${id}`,
                method: 'PUT',
                body:{...body}
            }),
            invalidatesTags: ['doctor'],
        }),

        createProcedure: builder.mutation<any, ICreateProcedure>({
            query: (body) => ({
                url: `api/adm/doctors/procedures`,
                method: 'POST',
                body:{...body}
            }),
            invalidatesTags: ['doctor'],
        }),
        editProcedure: builder.mutation<any, IEditProcedure>({
            query: ({id,body}) => ({
                url: `api/adm/doctors/procedures/${id}`,
                method: 'PUT',
                body:{...body}
            }),
            invalidatesTags: ['doctor'],
        }),
        saveDoctorsRecordingDuration: builder.mutation<any, IDoctorSaveBody>({
            query: ({doctorId,addressId, ...body}) => ({
                url: `api/adm/doctors/${doctorId}/address/${addressId}`,
                method: 'PATCH',
                body:{...body}
            }),
            invalidatesTags: ['doctor'],
        }),

    })
})

export const {
    useLazyGetDoctorsQuery,
    useGetOneDoctorsQuery,
    useGetSpecialitiesQuery,
    useCreateSpecialityMutation,
    useEditSpecialityMutation,
    useGetProceduresQuery,
    useCreateProcedureMutation,
    useEditProcedureMutation,
    useSaveDoctorsRecordingDurationMutation
} = endpoints